import React from 'react';
import { WARNING_TRIANGLE_ICON } from '@marvelapp/theme';
import { AspectRatio, Card, Icon, Text } from '@marvelapp/ui';
import PinCenter from './PinCenter';
export default function CardUploadError(_a) {
    var canEditProjects = _a.canEditProjects, hasImage = _a.hasImage, isSelected = _a.isSelected, ratio = _a.ratio, renderRetryLink = _a.renderRetryLink;
    var message = hasImage
        ? 'Looks like this image failed to upload.'
        : 'Looks like this image is broken.';
    return (React.createElement(Card, { isSelected: isSelected },
        React.createElement(AspectRatio, { ratio: ratio },
            React.createElement(PinCenter, { flexDirection: "column" },
                React.createElement(Icon, { color: "yellow", display: "block", height: 48, mb: 2, paths: WARNING_TRIANGLE_ICON, width: 48 }),
                React.createElement(Text, { fontSize: 3, maxWidth: "60%", mb: 1, textAlign: "center" },
                    message,
                    " ",
                    canEditProjects && renderRetryLink())))));
}
var renderRetryLink = function () { };
CardUploadError.defaultProps = {
    renderRetryLink: renderRetryLink,
};
